import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useStoredListLimit } from '../-useStoredListLimit';

const PermissionsIndexRedirect = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { appId } = Route.useParams();
  const limit = useStoredListLimit();

  useEffect(() => {
    navigate({
      to: '/administration/apps/$appId/permissions/users/$page/$limit',
      params: { appId, page: '1', limit: String(limit) },
    });
  }, [appId, limit, navigate]);

  return null;
};

export const Route = createFileRoute('/_secured/administration/apps/$appId/permissions/')({
  component: PermissionsIndexRedirect,
});
